/** 주문등록 화면에서 공지 팝업 API를 한 번만 호출하기 위한 sessionStorage 키 */
export const ORDER_REGISTER_NOTICE_POPUP_SESSION_KEY =
  'order_register_notice_popups_first_shown'
